import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const PartnerAuth = lazy(() => import("@/pages/PartnerAuth"));

export const Route = createFileRoute("/partner/activate")({
  component: PartnerAuth,
});
